import posthog, { type CapturedNetworkRequest } from "posthog-js";

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(
      import.meta.env.VITE_APP_POSTHOG_TOKEN,
      {
        api_host: import.meta.env.VITE_APP_POSTHOG_HOST,
        person_profiles: "identified_only",
        session_recording: {
          recordCrossOriginIframes: true,
          maskCapturedNetworkRequestFn: (request: CapturedNetworkRequest) => {
            return request;
          },
        },
      }
    );
  },
};
